<template>
  <VaSidebar v-model="writableVisible" :width="sidebarWidth" :color="color" minimized-width="0">
    <div class="flex flex-col h-full">
      <!--general routes sidebar-->
      <div v-if="area == 'general'">
        <h1 class="text-md text-slate-300 font-bold uppercase pl-2 py-4">{{ sidebarData.general.title }}</h1>
        <VaAccordion multiple>
          <VaCollapse v-for="(route, index) in sidebarData.general.routes" :key="index">
            <template #header="{ value: isCollapsed }">
              <VaSidebarItem
                :to="route.children ? undefined : { name: route.name }"
                :active="routeHasActiveChild(route)"
                :active-color="activeColor"
                :text-color="textColor(route)"
                :aria-label="`${route.children ? 'Open category ' : 'Visit'} ${route.displayName}`"
                role="button"
                hover-opacity="0.10"
              >
                <VaSidebarItemContent class="py-3 pl-4">
                  <VaIcon
                    v-if="route.meta.icon"
                    aria-hidden="true"
                    :name="route.meta.icon"
                    size="20px"
                    :color="iconColor(route)"
                  />
                  <VaSidebarItemTitle class="flex justify-between items-center leading-5 font-semibold">
                    {{ route.displayName }}
                    <VaIcon v-if="route.children" :name="arrowDirection(isCollapsed)" size="20px" />
                  </VaSidebarItemTitle>
                </VaSidebarItemContent>
              </VaSidebarItem>
            </template>
            <template #body>
              <div v-for="(childRoute, index2) in route.children" :key="index2">
                <VaSidebarItem
                  :to="{ name: childRoute.name }"
                  :active="isActiveChildRoute(childRoute)"
                  :active-color="activeColor"
                  :text-color="textColor(childRoute)"
                  :aria-label="`Visit ${route.displayName}`"
                  hover-opacity="0.10"
                >
                  <VaSidebarItemContent class="py-3 pl-11">
                    <VaSidebarItemTitle class="leading-5 font-semibold">
                      {{ childRoute.displayName }}
                    </VaSidebarItemTitle>
                  </VaSidebarItemContent>
                </VaSidebarItem>
              </div>
            </template>
          </VaCollapse>
        </VaAccordion>
      </div>
      <!--general routes sidebar-->

      <!--long stay permit routes sidebar items-->
      <div v-if="area == 'long_stay_permit'">
        <VaSidebarItem :to="{ name: 'services' }" aria-label="Back to Services" role="button" hover-opacity="0.10">
          <VaSidebarItemContent class="py-3 pl-4">
            <VaSidebarItemTitle class="flex justify-start items-center leading-5 font-semibold">
              <VaIcon name="arrow_left" size="20px" />
              Back to Services
            </VaSidebarItemTitle>
          </VaSidebarItemContent>
        </VaSidebarItem>
        <VaDivider />
        <h1 class="text-md text-slate-300 font-bold uppercase pl-4 pt-2">{{ sidebarData.long_stay_permit.title }}</h1>

        <VaAccordion multiple>
          <VaCollapse v-for="(route, index) in sidebarData.long_stay_permit.routes" :key="index">
            <template #header="{ value: isCollapsed }">
              <VaSidebarItem
                :to="route.children ? undefined : { name: route.name }"
                :active="routeHasActiveChild(route)"
                :active-color="activeColor"
                :text-color="textColor(route)"
                :aria-label="`${route.children ? 'Open category ' : 'Visit'} ${route.displayName}`"
                role="button"
                hover-opacity="0.10"
              >
                <VaSidebarItemContent class="py-3 pl-4">
                  <VaIcon
                    v-if="route.meta.icon"
                    aria-hidden="true"
                    :name="route.meta.icon"
                    size="20px"
                    :color="iconColor(route)"
                    class=""
                  />
                  <VaSidebarItemTitle class="flex justify-between items-center leading-5 font-semibold">
                    {{ route.displayName }}
                    <VaIcon v-if="route.children" :name="arrowDirection(isCollapsed)" size="20px" />
                  </VaSidebarItemTitle>
                </VaSidebarItemContent>
              </VaSidebarItem>
            </template>
            <template #body>
              <div v-for="(childRoute, index2) in route.children" :key="index2">
                <VaSidebarItem
                  :to="{ name: childRoute.name }"
                  :active="isActiveChildRoute(childRoute)"
                  :active-color="activeColor"
                  :text-color="textColor(childRoute)"
                  :aria-label="`Visit ${route.displayName}`"
                  hover-opacity="0.10"
                >
                  <VaSidebarItemContent class="py-3 pl-11">
                    <VaSidebarItemTitle class="leading-5 font-semibold">
                      {{ childRoute.displayName }}
                    </VaSidebarItemTitle>
                  </VaSidebarItemContent>
                </VaSidebarItem>
              </div>
            </template>
          </VaCollapse>
        </VaAccordion>
      </div>
      <!--long stay permit routes sidebar items-->

      <div class="flex flex-col flex-grow justify-end">
        <div>
          <VaDivider />
          <VaSidebarItem :to="{ name: 'logout' }" aria-label="logout" role="button" hover-opacity="0.10">
            <VaSidebarItemContent class="py-3 pl-4">
              <VaSidebarItemTitle class="flex justify-start items-center leading-5 font-semibold">
                <VaIcon name="logout" size="20px" class="" />
                Sign out
              </VaSidebarItemTitle>
            </VaSidebarItemContent>
          </VaSidebarItem>
          <VaDivider />
        </div>

        <div class="flex bg-[#234e7b] flex-col gap-2">
          <!--div class="flex flex-col max-w-[300px]">
            <RouterLink :to="{ name: 'services' }">
              <img
                src="@/assets/iis-connect-logo-dark.png"
                alt="Go to Home"
                title="Belize Immigration Service Portal Logo"
              />
            </RouterLink>
          </div>
          <div class="va-text-text-inverted text-[8px] max-w-[220px] ml-[68px]">
            Mountain View Boulevard, City of Belmopan, Cayo District, Belize C.A
          </div-->
          <div class="flex justify-center underline">
            <RouterLink :to="{ name: 'TOC' }">
              <span class="text-[10px]">Terms . Conditions . Privacy</span>
            </RouterLink>
          </div>
          <div class="bg-primary text-center flex flex-col items-center text-[10px] text-slate-400 py-2">
            © 2024 Government Of Belize | Ministry of Immigration
          </div>
        </div>
      </div>
    </div>
  </VaSidebar>
</template>
<script lang="ts">
import { defineComponent, watch, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import {
  useColors,
  VaAccordion,
  VaCollapse,
  VaDivider,
  VaIcon,
  VaSidebar,
  VaSidebarItem,
  VaSidebarItemContent,
  VaSidebarItemTitle,
} from 'vuestic-ui'

import navigationRoutes, { type INavigationRoute } from './NavigationRoutes'
import sidebarData from './SideBarData'

export default defineComponent({
  name: 'Sidebar',
  components: {
    VaDivider,
    VaSidebarItemTitle,
    VaSidebar,
    VaIcon,
    VaSidebarItemContent,
    VaSidebarItem,
    VaCollapse,
    VaAccordion,
  },
  props: {
    visible: { type: Boolean, default: true },
    mobile: { type: Boolean, default: false },
  },
  emits: ['update:visible'],

  setup: (props, { emit }) => {
    const { getColor, colorToRgba, currentPresetName } = useColors()
    const route = useRoute()

    const area = ref(route.meta.area)
    const value = ref<boolean[]>([])

    const writableVisible = computed({
      get: () => props.visible,
      set: (v: boolean) => emit('update:visible', v),
    })

    const isActiveChildRoute = (child: INavigationRoute) => route.name === child.name

    const routeHasActiveChild = (section: INavigationRoute) => {
      if (!section.children) {
        return route.name == section.name
      }

      return section.children.some(
        ({ name, displayName }) =>
          route.path.endsWith(`${name}`) || route.path.endsWith(`${displayName.toLowerCase()}`),
      )
    }

    const setActiveExpand = () => {
      value.value = navigationRoutes.routes.map((route: INavigationRoute) => routeHasActiveChild(route))
    }

    const sidebarWidth = computed(() => (props.mobile ? '100vw' : '280px'))
    const color = computed(() => getColor('sidebarColor'))
    const activeColor = computed(() => colorToRgba(getColor('focus'), 0.1))
    const currentTheme = computed(() => currentPresetName.value)
    const getTextColorFromTheme = () => {
      if (currentTheme.value == 'dark') return 'textPrimary'
      return 'textInverted'
    }

    const iconColor = (route: INavigationRoute) =>
      routeHasActiveChild(route) ? getTextColorFromTheme() : getTextColorFromTheme()
    const textColor = (route: INavigationRoute) =>
      routeHasActiveChild(route) ? getTextColorFromTheme() : getTextColorFromTheme()
    const arrowDirection = (state: boolean) => (state ? 'va-arrow-up' : 'va-arrow-down')

    watch(() => route.fullPath, setActiveExpand, { immediate: true })

    watch(
      () => route.meta,
      (value, oldValue) => {
        if (value != oldValue) area.value = route.meta.area
      },
      { immediate: true },
    )

    return {
      writableVisible,
      sidebarWidth,
      value,
      color,
      activeColor,
      navigationRoutes,
      sidebarData,
      routeHasActiveChild,
      isActiveChildRoute,
      iconColor,
      textColor,
      arrowDirection,
      area,
    }
  },
})
</script>
